import request from "@/util/http";
import qs from "qs"; // 获取全部标签列表

export var getAllLabelList = function getAllLabelList() {
  return request({
    url: "/admin/label/list",
    method: "get"
  });
}; // 获取标签信息

export var getLabelInfo = function getLabelInfo(id) {
  return request({
    url: "/admin/label/get/".concat(id),
    method: "get"
  });
}; // 删除标签

export var handleDelLabel = function handleDelLabel(id) {
  return request({
    url: "/admin/label/delete/".concat(id),
    method: "delete"
  });
}; // 移出

export var handleOut = function handleOut(params) {
  return request({
    url: "/admin/label/out",
    method: "delete",
    // method: 'get',
    params: params
  });
}; // 新增或编辑

export var handleSaveOrUpdate = function handleSaveOrUpdate(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/label/saveOrUpdate",
    method: "post",
    data: JSON.stringify(data)
  });
}; // 分页

export var gettLabelpage = function gettLabelpage(params) {
  return request({
    url: "/admin/label/page",
    method: "get",
    params: params
  });
}; // 获取标签信息

export var getStatInfo = function getStatInfo(id) {
  return request({
    url: "/admin/label/stat/".concat(id),
    method: "get"
  });
}; // 编辑

export var handleAddPost = function handleAddPost(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/label/addPost",
    method: "post",
    data: JSON.stringify(data)
  });
}; // 添加人员

export var handleAddUser = function handleAddUser(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/label/addUser",
    method: "post",
    data: JSON.stringify(data)
  });
};